// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageBoxMain":"gGlGk","imageClass":"Oo-SO","displayRadius":"NWMg0","imageAnim":"kT0fN","fadeinout":"rNoh6","loader":"fbvwV","image":"F7LzZ"};